export default __webpack_public_path__ + "static/media/info.630c1be2.svg";